import gql from 'graphql-tag';

import MenuImageFragment from './menu-image';
import MenuImagesFragment from './menu-images';
import RuleSetFragment from './rule-sets';
import VendorConfigsFragment from './vendor-configs';

const ItemMetaFragment = gql`
  fragment ItemMetaFragment on Item {
    _id
    _type
    operationalItem {
      daypart
    }
  }
`;

const ComboMetaFragment = gql`
  fragment ComboMetaFragment on Combo {
    _id
    _type
    mainItem {
      ...ItemMetaFragment
    }
  }
`;

const PickerMetaFragment = gql`
  fragment PickerMetaFragment on Picker {
    _id
    _type
    options {
      option {
        ...ItemMetaFragment
        ...ComboMetaFragment
      }
    }
  }
`;

const ActivateOfferMetaFragment = gql`
  fragment ActivateOfferMetaFragment on OfferActivation {
    _type
  }
`;

export default gql`
  fragment OffersFragment on Offer {
    _id
    _type
    name {
      localeRaw: _LANG_Raw
    }
    headerSuperText {
      locale: _LANG_
    }
    description {
      localeRaw: _LANG_Raw
    }
    moreInfo {
      localeRaw: _LANG_Raw
    }
    howToRedeem {
      localeRaw: _LANG_Raw
    }
    backgroundImage {
      ...MenuImageFragment
    }
    offerCTA {
      actionText {
        locale: _LANG_
      }
      route
    }
    forSupport
    daypart
    offerPrice
    marketPrice {
      ... on Item {
        vendorConfigs {
          ...VendorConfigsFragment
        }
      }
      ... on Combo {
        vendorConfigs {
          ...VendorConfigsFragment
        }
      }
    }
    localizedImage {
      locale: _LANG_ {
        ...MenuImagesFragment
      }
    }
    option {
      ...ComboMetaFragment
      ...ItemMetaFragment
      ...PickerMetaFragment
      ...ActivateOfferMetaFragment
    }
    shortCode
    ruleSet {
      ... on AllowRedemptionWithoutLogin {
        ...AllowRedemptionWithoutLogin
      }
      ... on BetweenDates {
        ...BetweenDates
      }
      ... on BetweenTimes {
        ...BetweenTimes
      }
      ... on CartProperty {
        ...CartProperty
      }
      ... on CoolDown {
        ...CoolDown
      }
      ... on DayOfWeekBand {
        ...DayOfWeekBand
      }
      ... on FirstOrderOnly {
        ...FirstOrderOnly
      }
      ... on Limit {
        ...Limit
      }
      ... on Purchase {
        ...Purchase
      }
      ... on RequiresAssignment {
        ...RequiresAssignment
      }
      ... on And {
        ruleSetType: _type
        ruleSet {
          ... on AllowRedemptionWithoutLogin {
            ...AllowRedemptionWithoutLogin
          }
          ... on BetweenDates {
            ...BetweenDates
          }
          ... on BetweenTimes {
            ...BetweenTimes
          }
          ... on CartProperty {
            ...CartProperty
          }
          ... on CoolDown {
            ...CoolDown
          }
          ... on DayOfWeekBand {
            ...DayOfWeekBand
          }
          ... on FirstOrderOnly {
            ...FirstOrderOnly
          }
          ... on Limit {
            ...Limit
          }
          ... on Purchase {
            ...Purchase
          }
          ... on RequiresAssignment {
            ...RequiresAssignment
          }
        }
      }

      ... on Or {
        ruleSetType: _type
        ruleSet {
          ... on AllowRedemptionWithoutLogin {
            ...AllowRedemptionWithoutLogin
          }
          ... on BetweenDates {
            ...BetweenDates
          }
          ... on BetweenTimes {
            ...BetweenTimes
          }
          ... on CartProperty {
            ...CartProperty
          }
          ... on CoolDown {
            ...CoolDown
          }
          ... on DayOfWeekBand {
            ...DayOfWeekBand
          }
          ... on FirstOrderOnly {
            ...FirstOrderOnly
          }
          ... on Limit {
            ...Limit
          }
          ... on Purchase {
            ...Purchase
          }
          ... on RequiresAssignment {
            ...RequiresAssignment
          }
        }
      }
    }
    vendorConfigs {
      ...VendorConfigsFragment
    }
  }
  ${ActivateOfferMetaFragment}
  ${MenuImageFragment}
  ${MenuImagesFragment}
  ${ComboMetaFragment}
  ${ItemMetaFragment}
  ${PickerMetaFragment}
  ${RuleSetFragment}
  ${VendorConfigsFragment}
`;
